import { ReactComponent as Logo } from '../../img/directful-logo.svg'
import styles from './Invoice.module.scss'

const InvoiceHeader = () => (
  <div>
    <div className={styles.header}>
      <Logo className={styles.directfulLogo} />
      <div className={styles.swaypayAddress}>
        <p className={styles.swaypayAddressName}>SwayPay, Inc</p>
        <p>
          1259 El Camino Real, Unit #1001
          <br />
          Menlo Park, CA 94025
        </p>
      </div>
    </div>
  </div>
)

export default InvoiceHeader
